/*
 * @Descripttion: CardTable的 Store
 * @version: 
 * @Author: bbq
 * @Date: 2020-06-28 13:37:53
 * @LastEditors: bbqin
 * @LastEditTime: 2021-09-27 10:39:28
 */

import { hookFactory } from '@platform/template';
import { MetaStore } from './components/SingleCardTable/store';
import { utils } from '@platform/table-core';
const { isArray, isUndefined, isString, isWrong, isObject } = utils;

class TableStore extends MetaStore {

    constructor(props = {}) {
        super(props);

        // 合并一下属性  不然会导致  get 方法取不到值 by bbqin
        this.store = {
            ...this.store,
            // moduleId
            name: props.name || '',
            // 所有CardTable的store  （目前是指cardTable的store）
            tableStores: {},
            // 所有CardTable的数据 
            // tableDatas: {}, // 不备份了
            // 初始模板
            meta: {},
            // 所有页签的数据 按照页签id区分
            // allTabsData: {}, // 不备份了
            // 所有表格的状态数据
            // allTabsStatus: {},  // 不备份了
            // 多语
            json: {},
            // 当前缺少项的页签集合
            errorTabIds: [],

            // 布局
            layout: 'horizontal',

            currentTab: {
                // 当前状态
                status: 'browse',
                // 当前操作页签
                tabId: '',
                tableId: '',
                // ...
            },
        }

        //console.log('12131', this.getHooks());
    }

    /**
     * @description: 复写
     * @param {type} 
     * @return: 
     */
    getStore(paths) {
        return super.get(paths);
    }

    /**
     * @description: 复写
     * @param {type} 
     * @return: 
     */
    setStore(paths, value, shouldForceUpdate = true, callback) {
        let res = super.set(paths, value);
        shouldForceUpdate && this.forceUpdate(callback);
        return res;
    }

    // 多来源页签的布局
    setLayout(layout, shouldForceUpdate = true) {
        layout = layout || this.getStore(['currentTab', 'layout']);
        this.setStore(['currentTab', 'layout'], layout === 'vertical' ? 'vertical' : 'horizontal', shouldForceUpdate);
    }


    /**
     * @description: 获取模板的属性
     * @param {type} 
     * @return: 
     */
    _getMetaRelation() {
        let { gridrelation = {}, containerrelation = {} } = this.getMeta();
        return { gridrelation, containerrelation };
    }

    /**
     * @description: 获取所有的tabs
     * @param {type} 
     * @return: 
     */
    _getTabs(name) {
        name = name || this.getStore('name');
        let { containerrelation } = this._getMetaRelation();
        return containerrelation[name] || [];
    }

    /**
     * @description: 批量操作子表
     * @param {type} 
     * @return: 
     */
    _batchTabsTable(func, name) {
        name = name || this.getStore('name');
        if (!name) { console.warn('not find name[%s] tableStore ') }

        let { gridrelation, containerrelation } = this._getMetaRelation();

        let tabs = this._getTabs(name);

        //let layout = this.getLayout(name);

        let stores = this.getStore('tableStores');

        console.log(name, tabs, gridrelation, containerrelation, stores);

        // 先简单处理下
        // if (layout === 'horizontal' && isArray(tabs[0])) {
        //     tabs = [tabs[0]]; // 设置全部也不是不行 并不行  data 还没有初始化  如果初始化了 应该可以
        // }

        let res = tabs.map(ids => {
            ids.map(id => {
                if (!id) {
                    return console.warn('invalid id');
                }

                let currentStore = stores[id];

                if (name && id === name) {
                    currentStore = this;
                }

                if (!currentStore) {
                    console.warn(`tableId 为${id} 表格，没有初始化对应的Store，请不要进行批操作。`);
                }

                return currentStore && func(currentStore, id, name, tabs);
            });
        });

        return res;
    }

    // 设置多来源的所有数据
    setTabsTableData(data, shouldForceUpdate = true, name) {

        if (!data) {
            data = {};
        }

        this._batchTabsTable((store, id) => {
            if (!data[id]) {
                console.warn("not find id[%s] data", id);
            }
            if (data[id]) {
                let activeTableCode = store.getStore('activeTableCode');
                console.log("获取当前显示的页签编码：", store.getStore('activeTableCode'));
                store.setTableData(data[id], {
                    shouldForceUpdate: shouldForceUpdate && id === activeTableCode, //初始化更新时，业务数字无法更新
                    //shouldForceUpdate: false,
                    autoFocus: false,
                });
            }

        }, name);

        //shouldForceUpdate && this.forceUpdate();
    }

    // 重置所有页签的数据
    resetTabsTableData(shouldForceUpdate = false, name) {
        this._batchTabsTable((store, id) => {
            if (store) {
                store.resetTableData();
            }
        }, name);
        shouldForceUpdate && this.forceUpdate();
    }

    // 获取所有行的数据
    getTabsTableData(name) {
        let res = {};
        this._batchTabsTable((store, id) => {
            if (store) {
                let data = store.getData();
                res[id] = { rows: data };
            }
        }, name);
        console.log(res);
        return res;
    }

    // 设置所有页签（cardTable）的状态
    setTabsTableStatus(status = {}, shouldForceUpdate = true, name, callback) {
        this._batchTabsTable((store, id) => {
            if (status[id]) {
                let activeTableCode = store.getStore('activeTableCode');
                let oldStatus = store.getTableProps('status') || 'browse';
                store.setTableStatus(status[id], { shouldForceUpdate: activeTableCode === id && shouldForceUpdate });
                callback && callback(id, store, oldStatus);
            }
        }, name);
        // shouldForceUpdate && this.forceUpdate();
    }

    // 获取多页签所有的 stores
    getTabsStores(id, name) {
        name = name || this.getStore('name');
        if (!name) { console.warn('not find name[%s] tableStore ', name) }
        let res = Object.assign({}, { [name]: this }, this.getStore('tableStores'));
        return id ? res[id] : res;
    }

    // 添加stores 缓存数据中
    addTabStore(id, store, pattern, shouldForceUpdate = false) {
        let tableStores = this.getStore('tableStores');
        tableStores[id] = store;
        this.setStore('tableStores', tableStores, shouldForceUpdate);
    }

    //设置页签显示隐藏
    setTabsTableShow(mainId, flagObj, shouldForceUpdate = true) {
        let tabs = this._getTabs(mainId);
        let stores = this.getStore('tableStores');
        if (isArray(tabs)) {
            tabs.forEach((item) => {
                //tabs每一项是一个垂直排列的表格
                let mainCode = item[0];
                if (stores[mainCode]) {
                    let hideTabsCode = stores[mainCode].getStore('hideTabsCode');
                    for (let code in flagObj) {
                        if (item.includes(code)) {
                            hideTabsCode[code] = !flagObj[code];
                        }
                    }
                    stores[mainCode].setStore('hideTabsCode', hideTabsCode, shouldForceUpdate);
                }
            })
        }
    }

    //设置当前激活页签
    setTabsTableActive(mainId, activeCode, shouldForceUpdate = true) {
        let tabs = this._getTabs(mainId);
        let stores = this.getStore('tableStores');
        if (isArray(tabs)) {
            tabs.forEach((item) => {
                if (item.includes(activeCode)) {
                    let mainCode = item[0];
                    let tableSwitch = stores[mainCode].getStore('tableSwitch');
                    tableSwitch.activeCode = activeCode;
                    stores[mainCode] && stores[mainCode].setStore('tableSwitch', tableSwitch, shouldForceUpdate);
                }
            })
        }
    }

    //获取当前激活页签
    getTabsTableActive(mainId) {
        let tabs = this._getTabs(mainId);
        let stores = this.getStore('tableStores');
        if (isArray(tabs)) {
            return tabs.map((item) => {
                let mainCode = item[0];
                if (stores[mainCode]) {
                    return stores[mainCode].getStore('tableSwitch').activeCode;
                }
            })
        }
        return [];
    }

    // 校验数据
    checkTableRequired({ items, rows, allToast = {}, rowKey, json } = {}) {
        let validateFailed = {}, firstValidateFailed;

        // 没必要单做  可以合并下
        // items.forEach(item => {
        //     //将数据中没有的列附上空对象，保证校验的准确性
        //     const { attrcode } = item;
        //     rows.forEach(row => {
        //         const { values } = row;
        //         if (isUndefined(values[attrcode])) {
        //             values[attrcode] = {};
        //         }
        //     });
        // });
        let requiredItems = items.filter(item => item.required && item.visible);

        rows.forEach((row, index) => {
            const rowToast = []; //保存每行的检验提示信息
            const { values } = row;
            const rowKeyValue = row[rowKey];
            // 有序
            requiredItems.forEach(item => {
                const { attrcode, label } = item;
                let columnValue = (values[attrcode] || {}).value;

                if (isString(columnValue)) {
                    columnValue = columnValue.trim();
                }
                if (isWrong(columnValue)) {
                    rowToast.push(label);
                    // 有就是有没有就是没有  给页签上判断用
                    validateFailed[rowKeyValue] = validateFailed[rowKeyValue] || {};
                    validateFailed[rowKeyValue][attrcode] = attrcode;
                    if (!firstValidateFailed) {
                        firstValidateFailed = [rowKeyValue, attrcode];
                    }
                }

            });

            if (rowToast.length > 0) {
                allToast[`${json && json['table_first']}${index + 1}${json && json['table_row']}`] = rowToast;
            }
        });

        return { tabToast: allToast, validateFailed, firstValidateFailed: firstValidateFailed };
    }

    // 校验所有的页签
    checkTabsTableRequired(tableId, autoFocus = true) {
        // meta
        const meta = this.getMeta();
        // 多语
        const json = this.getCache('langJson') || {};
        // 表格关系
        const { gridrelation, containerrelation } = meta;
        // 所有页签store
        const tabsStores = this.getTabsStores(undefined, tableId);
        // 多页签所有的主表(二维数组)
        let tabs = containerrelation ? containerrelation[tableId] : [[tableId]];
        tabs = tabs && isArray(tabs) && tabs.length ? tabs : [[tableId]];
        // 降维方便操作
        tabs = tabs.reduce((all, item) => {
            all.push(...item);
            return all;
        }, []);

        // 校验结果
        let allValidateFailed = {};
        let allFirstValidateFailed = {};
        // 必输项不全的页签
        const errorTabIds = [];
        // 提示信息集合
        const errorItemsInfo = {};

        // 构造用校验的数据集合
        const checkedMusters = tabs.reduce((checkedMuster, tabId) => {
            // 共享页签关系
            const currentRelation = gridrelation[tabId];
            // store
            const currentStore = tabsStores[tabId];
            if (!currentStore || !currentRelation) {
                return checkedMuster;
            }
            // 表格数据，只校验过滤数据，可能有些问题
            const rows = currentStore.getViewData('filter');
            // 共享页签
            const tabRelation = currentRelation.initialTabRelation || currentRelation.tabRelation;
            // 字面量化共享页签所有的项
            const tabRelationMuster = tabRelation.reduce((metaConfig, tabId) => {
                const name = meta[tabId].name;
                let items = currentStore.getArrayMeta(tabId) || [];
                items = items.filter(item => item.visible);
                metaConfig[tabId] = { name, items };
                return metaConfig;
            }, {});

            checkedMuster[tabId] = { tabRelationMuster, rows };
            return checkedMuster;
        }, {});

        // 开始校验
        for (let tableId in checkedMusters) {
            // 获取store
            const tabItem = checkedMusters[tableId];
            let store = tabsStores[tableId];
            // 获取rowKeyValue
            const rowKey = store ? store.getTableProps('rowKey') : 'rowid';
            // 初始化校验结果
            allValidateFailed[tableId] = allValidateFailed[tableId] || {};
            allFirstValidateFailed[tableId] = allFirstValidateFailed[tableId] || [];

            const { tabRelationMuster, rows } = tabItem;
            Object.entries(tabRelationMuster).forEach(([tabId, config]) => {
                const { name, items } = config;
                const { tabToast, validateFailed, firstValidateFailed } = this.checkTableRequired({ items, rows, rowKey, json });

                allValidateFailed[tableId][tabId] = allValidateFailed[tableId][tabId] || {};

                if (Object.keys(tabToast).length) {
                    allValidateFailed[tableId][tabId] = validateFailed;
                    if (!allFirstValidateFailed[tableId].length) {
                        allFirstValidateFailed[tableId] = [tabId, ...firstValidateFailed];
                    }
                    errorTabIds.push(tabId);
                    errorItemsInfo[`${name}(${json && json['table008']})${json && json['table_no_empty']}`] = tabToast;
                }
            });
        }

        // 校验结果处理
        let errorContent = '',
            passed = true;
        if (errorTabIds.length) {
            // validateFailed, firstValidateFailed // 四层数据
            console.log(allValidateFailed, allFirstValidateFailed, errorTabIds, errorItemsInfo);
            for (let tableId in allValidateFailed) {
                const store = tabsStores[tableId];
                const table = allValidateFailed[tableId];
                let isRefresh = false;
                if (store && table) {
                    // console.log(store);
                    // 缓存状态
                    store.setCache('validateFailed', allValidateFailed);
                    store.setCache('firstValidateFailed', allFirstValidateFailed);
                    for (let tabId in table) {
                        const rows = table[tabId];
                        if (rows) {
                            for (let rowKeyValue in rows) {
                                if (rowKeyValue) {
                                    let row = rows[rowKeyValue];
                                    if (row) {
                                        for (let attrcode in row) {
                                            store.setCellProps(rowKeyValue, attrcode, { validated: false }, false);
                                        }
                                    }
                                    isRefresh = true;
                                }
                            }

                        }
                    }
                    isRefresh && store.refresh();
                }
            }
            this.setStore('errorTabIds', errorTabIds);

            // 自动聚焦到首个
            if (allFirstValidateFailed && autoFocus) {
                const tableIdList = tabs ? (isArray(tabs) ? tabs : [tabs]) : tabs;

                let tabSelector = null,
                    cellSelector = null;
                // 找到第一个
                tableIdList.some(tableId => {
                    let cellInfo = allFirstValidateFailed[tableId];
                    if (cellInfo && cellInfo.length > 0) {
                        tabSelector = `#js_lightTabs_header_${tableId} [name="${cellInfo[0]}"] a`;
                        cellSelector = `.table-cell-wrapper[cellselectorkey="${cellInfo[1]}@${cellInfo[2]}"] [tabindex="0"]`;
                        return true;
                    }
                });

                const tabElement = document.querySelector(tabSelector);

                tabElement && tabElement.click();

                setTimeout(() => {
                    const cellElement = document.querySelector(cellSelector);
                    if (cellElement) {
                        cellElement.ncExecuteFocus = true;
                        cellElement.focus();
                        cellElement.ncExecuteFocus = false;
                    }
                }, 300)

                console.log(tableIdList, allFirstValidateFailed, tabSelector, cellSelector);
            }
            errorContent = Object.entries(errorItemsInfo).reduce((errorContent, [tabName, rowsToast]) => {
                errorContent += `${tabName} :\n`;
                Object.entries(rowsToast).forEach(([rowName, rowToast]) => {
                    errorContent += `${rowName}: ${rowToast.join('、 ')};\n`;
                });
                return errorContent;
            }, '');

            passed = false;
        } else {
            this.setStore('errorTabIds', [], true);
            this.setCache('errorContent', []);
        }

        return {
            requiredItems: allValidateFailed,
            regExpItem: [],
            maxItems: [],
            content: errorContent,
            passed,
        }
    }

    // 孙表校验
    getChildTableRequired(tabsStores, parentIds = {}, childRowKey = 'rowid') {

        if (!parentIds) { console.error('not get tableId'); }

        const json = this.getCache('langJson') || {};
        const meta = this.getMeta();
        const { gridrelation, containerrelation } = meta;

        if (containerrelation) {
            console.log('current meta include mutil containerrelation');
        }

        // 整表校验
        const allErrorInfo = [];

        // 可能会有效率问题
        for (let parentId in parentIds) {
            const childIds = parentIds[parentId] || [];
            const parentStore = tabsStores[parentId];
            // 所有子表行
            const parentData = parentStore && parentStore.getViewData('filter');

            if (parentData) {
                // 所有孙表数据
                let grandTableDatas = parentStore.getStore('grandTable') || {};
                // console.log(grandTableData, parentData);
                const parentRowKey = parentStore.getTableProps('rowKey') || 'rowid';

                // 当前表
                const parentErrorInfo = [];
                parentData.forEach((prow, pindex) => {
                    let grandTableData = grandTableDatas[prow[parentRowKey]] || {};
                    if (grandTableData) {
                        // 校验缓存
                        const errorInfo = {
                            key: {},
                            label: {},
                            ids: [],
                        };
                        const validateFailed = {};
                        const firstValidateFailed = {};

                        childIds.forEach(tableId => {
                            const idInfo = gridrelation[tableId] || {};
                            errorInfo.key[tableId] = {};
                            const tableName = meta[tableId]['name'] || json['table0010'];

                            //  校验
                            validateFailed[tableId] = validateFailed[tableId] || {};
                            firstValidateFailed[tableId] = firstValidateFailed[tableId] || {};

                            // 获取孙表的rowKey
                            let store = tabsStores[tableId];
                            const childRowKey = store ? store.getTableProps('rowKey') : childRowKey;

                            errorInfo.ids.push(tableName);

                            const tableLabel = `${json['table007']}_` + tableName + ' > ';
                            errorInfo.label[tableLabel] = {};
                            // 筛选之前的代码
                            const rows = (grandTableData[tableId] || {}).rows || [];

                            const tableDataRows = rows.filter(item => item.status != ROW_STATUS.delete);

                            // destEditAreaCode是侧拉项  tabRelation为页签项
                            const { tabRelation = [tableId] } = idInfo;

                            // 共享页签
                            if (tabRelation.length) {
                                tabRelation.forEach(idMain => {
                                    const tabId = idMain + '_TAB';
                                    const tabName = meta[idMain]['name'] || json['table009'];
                                    const tabLabel = `${tabName}(${json['table008']})` + ' ： ';
                                    errorInfo.key[tableId][tabId] = {};
                                    errorInfo.label[tableLabel][tabLabel] = {};

                                    validateFailed[tableId][idMain] = {};

                                    // idMain 为主表内的不同页签  itemsMain可能会多表头
                                    let itemsMain = isObject(meta[idMain]) ? meta[idMain].items : [];

                                    itemsMain = itemsMain.getArrayData ? itemsMain.getArrayData() : _getAllItem(itemsMain); // 处理侧拉多表头

                                    // itemsMain  兼容
                                    itemsMain = itemsMain.getArrayData ? itemsMain.getArrayData() : itemsMain;

                                    itemsMain.forEach(item => {
                                        if (!!item.required && !!item.visible && tableDataRows.length > 0) {
                                            tableDataRows.forEach((val, index) => {
                                                const cellLabel = `${json['table_first']}${index + 1}${json['table_row']}：`;
                                                errorInfo.key[tableId][tabId][index] = errorInfo.key[tableId][tabId][index] || {};
                                                errorInfo.label[tableLabel][tabLabel][cellLabel] = errorInfo.label[tableLabel][tabLabel][cellLabel] || {};

                                                if (val.values[item.attrcode]) {
                                                    const checkedValue = val.values[item.attrcode].value;
                                                    if (isWrong(checkedValue)) {
                                                        errorInfo.key[tableId][tabId][index][item.attrcode] = item.label;
                                                        errorInfo.label[tableLabel][tabLabel][cellLabel][item.label] = ' 为空';

                                                        // 有就是有没有就是没有  给页签上判断用
                                                        validateFailed[tableId][idMain][val[childRowKey]] = validateFailed[tableId][idMain][val[childRowKey]] || {};
                                                        validateFailed[tableId][idMain][val[childRowKey]][item.attrcode] = item.attrcode;
                                                        if (!Object.keys(firstValidateFailed[tableId]).length) {
                                                            firstValidateFailed[tableId][idMain] = {};
                                                            firstValidateFailed[tableId][idMain][val[childRowKey]] = item.attrcode;
                                                        }
                                                    }
                                                } else {
                                                    errorInfo.key[tableId][tabId][index][item.attrcode] = item.label;
                                                    errorInfo.label[tableLabel][tabLabel][cellLabel][item.label] = ' 为空';

                                                    // 有就是有没有就是没有  给页签上判断用
                                                    validateFailed[tableId][idMain][val[childRowKey]] = validateFailed[tableId][idMain][val[childRowKey]] || {};
                                                    validateFailed[tableId][idMain][val[childRowKey]][item.attrcode] = item.attrcode;
                                                    if (!Object.keys(firstValidateFailed[tableId]).length) {
                                                        firstValidateFailed[tableId][idMain] = {};
                                                        firstValidateFailed[tableId][idMain][val[childRowKey]] = item.attrcode;
                                                    }
                                                }
                                            });
                                        }
                                    });
                                });
                            }
                        });

                        errorInfo.validateFailed = validateFailed;
                        errorInfo.firstValidateFailed = firstValidateFailed;

                        // 行信息
                        parentErrorInfo.push({
                            index: pindex,
                            rowKeyValue: prow[parentRowKey],
                            info: `${json['table_first']}${pindex + 1}${json['table_row']}：`,
                            errorInfo,
                        });
                    }
                });

                // 表信息
                allErrorInfo.push({
                    id: parentId,
                    info: meta[parentId]['name'] || json['table0010'],
                    row: parentErrorInfo,
                });
            }
        }

        return allErrorInfo;
    }

    // 孙表校验
    checkChildTableRequired(tableId, parentIds = {}, childRowKey = 'rowid') {
        const json = this.getCache('langJson') || {};
        // 所有页签store
        const tabsStores = this.getTabsStores(undefined, tableId);

        let allErrorInfo = this.getChildTableRequired(tabsStores, parentIds, childRowKey);

        let isRequired = false;
        // 校验信息
        let toastMessage = [];

        // 被检验住的行
        const requiredRows = { isNoRequired: false };
        // 校验信息
        allErrorInfo.forEach(pinfo => {
            requiredRows[pinfo.id] = {};
            if (pinfo.row) {
                // 缓存记录
                let grandValidateFailed = {};
                pinfo.row.forEach(rowInfo => {
                    const parentLabel = pinfo.info + rowInfo.info;

                    // 父表
                    toastMessage.push('>>> ' + parentLabel);

                    const { label, ids, validateFailed = {}, firstValidateFailed = {} } = rowInfo.errorInfo;
                    // 记录
                    grandValidateFailed[rowInfo.rowKeyValue] = validateFailed;
                    // 被检验住的行
                    const childRequiredRows = { isNoRequired: false };
                    let messageWrong = []; //需要校验的表格
                    messageWrong = Object.keys(label).filter(item =>
                        ids.some(item1 => item.startsWith(`${json['table007']}_${item1}`)),
                    );
                    messageWrong.forEach(eve => {
                        const labelItem = label[eve];
                        childRequiredRows[eve] = {};
                        Object.keys(labelItem).forEach(key => {
                            childRequiredRows[eve][key] = { childRequiredRows: [] };
                            const labelItemChild = labelItem[key];
                            let pagelabel = '';
                            if (
                                Object.keys(labelItemChild).length > 0 &&
                                Object.keys(labelItemChild).filter(key => {
                                    return Object.keys(labelItemChild[key]).length;
                                }).length
                            ) {
                                pagelabel = key;
                            }
                            toastMessage.push(pagelabel);
                            Object.keys(labelItemChild).forEach((cont, index) => {
                                if (Object.keys(labelItemChild[cont]).length > 0) {
                                    childRequiredRows[eve][key]['childRequiredRows'].push(index);
                                    isRequired = true;
                                    //对输出的校验内容进行格式转化
                                    let str =
                                        cont +
                                        `${Object.keys(labelItemChild[cont])
                                            .map(ele => {
                                                return `[${ele}]`;
                                            })
                                            .join('，')}；`;
                                    toastMessage.push(str);
                                }
                            });
                        });
                    });

                    // 记录结果
                    requiredRows[pinfo.id][rowInfo.index] = childRequiredRows;
                });
                if (isRequired) {
                    const store = tabsStores[pinfo.id];
                    store && store.setCache('grandValidateFailed', grandValidateFailed);
                }

            }
        })

        return {
            requiredItems: requiredRows,
            regExpItem: [],
            maxItems: [],
            content: toastMessage,
            passed: !isRequired,
        }
    }

    getHooks() {
        return {
            ...super.getHooks(),
            //模板
            // // all
            getStore: this.getStore.bind(this),
            setStore: this.setStore.bind(this),

            setLayout: this.setLayout.bind(this),
            // getLayout: this.getLayout.bind(this),
            setTabsTableData: this.setTabsTableData.bind(this),
            resetTabsTableData: this.resetTabsTableData.bind(this),
            getTabsTableData: this.getTabsTableData.bind(this),
            setTabsTableStatus: this.setTabsTableStatus.bind(this),
            getTabsStores: this.getTabsStores.bind(this),
            addTabStore: this.addTabStore.bind(this),
            setTabsTableShow: this.setTabsTableShow.bind(this),
            setTabsTableActive: this.setTabsTableActive.bind(this),
            getTabsTableActive: this.getTabsTableActive.bind(this),
            checkTabsTableRequired: this.checkTabsTableRequired.bind(this),
        };
    }
}

export default hookFactory(TableStore);